import React from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "../SchedaSpecialeMIB.module.css"
import Utils from "../../../../../../../utils/Utils";
import {Util} from "reactstrap";

class MalattiaBattericaMIB extends React.Component {

    state = {
        malattiaBatterica: {
            checkboxMalattia1: this.props.statePadre && this.props.statePadre.checkboxMalattia1 ? this.props.statePadre.checkboxMalattia1 : "",
            checkboxMalattia2: this.props.statePadre && this.props.statePadre.checkboxMalattia2 ? this.props.statePadre.checkboxMalattia2 : "",
            checkboxMalattia3: this.props.statePadre && this.props.statePadre.checkboxMalattia3 ? this.props.statePadre.checkboxMalattia3 : "",
            checkboxMalattia4: this.props.statePadre && this.props.statePadre.checkboxMalattia4 ? this.props.statePadre.checkboxMalattia4 : "",
            checkboxMalattia5: this.props.statePadre && this.props.statePadre.checkboxMalattia5 ? this.props.statePadre.checkboxMalattia5 : "",
            checkboxMalattia6: this.props.statePadre && this.props.statePadre.checkboxMalattia6 ? this.props.statePadre.checkboxMalattia6 : "",
            checkboxMalattia7: this.props.statePadre && this.props.statePadre.checkboxMalattia7 ? this.props.statePadre.checkboxMalattia7 : "",
            checkboxMalattia8: this.props.statePadre && this.props.statePadre.checkboxMalattia8 ? this.props.statePadre.checkboxMalattia8 : "",
            checkboxMalattia9: this.props.statePadre && this.props.statePadre.checkboxMalattia9 ? this.props.statePadre.checkboxMalattia9 : "",
            checkboxMalattia10: this.props.statePadre && this.props.statePadre.checkboxMalattia10 ? this.props.statePadre.checkboxMalattia10 : "",
            checkboxMalattia11: this.props.statePadre && this.props.statePadre.checkboxMalattia11 ? this.props.statePadre.checkboxMalattia11 : "",
            checkboxMalattia12: this.props.statePadre && this.props.statePadre.checkboxMalattia12 ? this.props.statePadre.checkboxMalattia12 : "",
            checkboxMalattia13: this.props.statePadre && this.props.statePadre.checkboxMalattia13 ? this.props.statePadre.checkboxMalattia13 : "",
            checkboxMalattia14: this.props.statePadre && this.props.statePadre.checkboxMalattia14 ? this.props.statePadre.checkboxMalattia14 : "",
            checkboxMalattia15: this.props.statePadre && this.props.statePadre.checkboxMalattia15 ? this.props.statePadre.checkboxMalattia15 : "",
            checkboxMalattia16: this.props.statePadre && this.props.statePadre.checkboxMalattia16 ? this.props.statePadre.checkboxMalattia16 : "",
            checkboxMalattia17: this.props.statePadre && this.props.statePadre.checkboxMalattia17 ? this.props.statePadre.checkboxMalattia17 : "",
            checkboxMalattia18: this.props.statePadre && this.props.statePadre.checkboxMalattia18 ? this.props.statePadre.checkboxMalattia18 : "",
            checkboxMalattia19: this.props.statePadre && this.props.statePadre.checkboxMalattia19 ? this.props.statePadre.checkboxMalattia19 : "",
            checkboxMalattia20: this.props.statePadre && this.props.statePadre.checkboxMalattia20 ? this.props.statePadre.checkboxMalattia20 : "",
            checkboxMalattia21: this.props.statePadre && this.props.statePadre.checkboxMalattia21 ? this.props.statePadre.checkboxMalattia21 : "",
            altro: this.props.statePadre && this.props.statePadre.altro ? this.props.statePadre.altro : "",
            esitoConosciuto: this.props.statePadre && this.props.statePadre.esitoConosciuto ? this.props.statePadre.esitoConosciuto : "",
            corretto: [],
        },
        boxes: [],
        radioBoxes: []
    }

    constructor(props) {
        super(props)
        this.riceviValore = this.riceviValore.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
        this.controlloDatiBatterica = this.controlloDatiBatterica.bind(this);
        this.generateCheckBoxDiv = this.generateCheckBoxDiv.bind(this)
        this.generateRadioDiv = this.generateRadioDiv.bind(this)
    }

    componentDidMount() {
        let malattiaBatterica = this.state.malattiaBatterica

        let statePadre = JSON.parse(JSON.stringify(this.props.statePadre))
        delete statePadre["corretto"];

        if(Utils.isEmpty(statePadre)) {
            if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.malattiaBattericaMIB) {
                let malattiaBattericaProps = this.props.segnalazioneCopia.schedaSpeciale.malattiaBattericaMIB

                for (let i = 1; i < 22; i++) {
                    malattiaBatterica["checkboxMalattia" + i] = this.props.statePadre && this.props.statePadre["checkboxMalattia" + i] ? this.props.statePadre["checkboxMalattia" + i] : malattiaBattericaProps["checkboxMalattia" + i] ? malattiaBattericaProps["checkboxMalattia" + i] : ""
                }
                malattiaBatterica.altro = this.props.statePadre && this.props.statePadre.altro ? this.props.statePadre.altro : malattiaBattericaProps.altro ? malattiaBattericaProps.altro : ""
                malattiaBatterica.esitoConosciuto = this.props.statePadre && this.props.statePadre.esitoConosciuto ? this.props.statePadre.esitoConosciuto : malattiaBattericaProps.esitoConosciuto ? malattiaBattericaProps.esitoConosciuto : ""
            }
        }
        let boxes = this.generateCheckBoxDiv()
        let radioBoxes = this.generateRadioDiv()
        this.setState({malattiaBatterica: malattiaBatterica, boxes: boxes, radioBoxes: radioBoxes});
        this.controlloDatiBatterica();
        let oggetto = this.createOggettoBE()
        this.props.setMalattiaBattericaMIB(this.state.malattiaBatterica, oggetto)
    }

    controlloDatiBatterica() {
        let malattiaBatterica = this.state.malattiaBatterica
        malattiaBatterica.corretto = []

        if(malattiaBatterica.checkboxMalattia21 && !malattiaBatterica.altro) malattiaBatterica.corretto[0] = "Campo \"Altra condizione\" mancante";

        this.setState({malattiaBatterica: malattiaBatterica})
    }

    createOggettoBE() {
        let malattiaBatterica = JSON.parse(JSON.stringify(this.state.malattiaBatterica))
        let malattiaBattericaBe = Utils.removeEmptyValueFromObject(malattiaBatterica)
        return Utils.removeFieldFromObject(malattiaBattericaBe, "corretto")
    }

    generateCheckBoxDiv() {
        const {t} = this.props
        let rows = [
            {
                checkboxMalattia1: {
                    id: "checkboxMalattia1",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.1",
                    tipo: "check",
                    field: "checkboxMalattia1",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia1,
                    fontColor: "black",
                    colonna: 1
                },
                checkboxMalattia12: {
                    id: "checkboxMalattia12",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.12",
                    tipo: "check",
                    field: "checkboxMalattia12",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia12,
                    fontColor: "black",
                    colonna: 2
                },
            },
            {
                checkboxMalattia2: {
                    id: "checkboxMalattia2",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.2",
                    tipo: "check",
                    field: "checkboxMalattia2",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia2,
                    fontColor: "black",
                    colonna: 1
                },
                checkboxMalattia13: {
                    id: "checkboxMalattia13",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.13",
                    tipo: "check",
                    field: "checkboxMalattia13",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia13,
                    fontColor: "black",
                    colonna: 2
                },
            },
            {
                checkboxMalattia3: {
                    id: "checkboxMalattia3",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.3",
                    tipo: "check",
                    field: "checkboxMalattia3",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia3,
                    fontColor: "black",
                    colonna: 1
                },
                checkboxMalattia14: {
                    id: "checkboxMalattia14",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.14",
                    tipo: "check",
                    field: "checkboxMalattia14",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia14,
                    fontColor: "black",
                    colonna: 2
                },
            },
            {
                checkboxMalattia4: {
                    id: "checkboxMalattia4",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.4",
                    tipo: "check",
                    field: "checkboxMalattia4",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia4,
                    fontColor: "black",
                    colonna: 1
                },
                checkboxMalattia15: {
                    id: "checkboxMalattia15",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.15",
                    tipo: "check",
                    field: "checkboxMalattia15",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia15,
                    fontColor: "black",
                    colonna: 2
                },
            },
            {
                checkboxMalattia5: {
                    id: "checkboxMalattia5",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.5",
                    tipo: "check",
                    field: "checkboxMalattia5",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia5,
                    fontColor: "black",
                    colonna: 1
                },
                checkboxMalattia16: {
                    id: "checkboxMalattia16",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.16",
                    tipo: "check",
                    field: "checkboxMalattia16",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia16,
                    fontColor: "black",
                    colonna: 2
                },
            },
            {
                checkboxMalattia6: {
                    id: "checkboxMalattia6",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.6",
                    tipo: "check",
                    field: "checkboxMalattia6",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia6,
                    fontColor: "black",
                    colonna: 1
                },
                checkboxMalattia17: {
                    id: "checkboxMalattia17",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.17",
                    tipo: "check",
                    field: "checkboxMalattia17",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia17,
                    fontColor: "black",
                    colonna: 2
                },
            },
            {
                checkboxMalattia7: {
                    id: "checkboxMalattia7",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.7",
                    tipo: "check",
                    field: "checkboxMalattia7",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia7,
                    fontColor: "black",
                    colonna: 1
                },
                checkboxMalattia18: {
                    id: "checkboxMalattia18",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.18",
                    tipo: "check",
                    field: "checkboxMalattia18",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia18,
                    fontColor: "black",
                    colonna: 2
                },
            },
            {
                checkboxMalattia8: {
                    id: "checkboxMalattia8",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.8",
                    tipo: "check",
                    field: "checkboxMalattia8",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia8,
                    fontColor: "black",
                    colonna: 1
                },
                checkboxMalattia19: {
                    id: "checkboxMalattia19",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.19",
                    tipo: "check",
                    field: "checkboxMalattia19",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia19,
                    fontColor: "black",
                    colonna: 2
                },
            },
            {
                checkboxMalattia9: {
                    id: "checkboxMalattia9",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.9",
                    tipo: "check",
                    field: "checkboxMalattia9",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia9,
                    fontColor: "black",
                    colonna: 1
                },
                checkboxMalattia20: {
                    id: "checkboxMalattia20",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.20",
                    tipo: "check",
                    field: "checkboxMalattia20",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia20,
                    fontColor: "black",
                    colonna: 2
                },
            },
            {
                checkboxMalattia10: {
                    id: "checkboxMalattia10",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.10",
                    tipo: "check",
                    field: "checkboxMalattia10",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia10,
                    fontColor: "black",
                    colonna: 1
                },
                checkboxMalattia21: {
                    id: "checkboxMalattia21",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.21",
                    tipo: "check",
                    field: "checkboxMalattia21",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia21,
                    fontColor: "black",
                    colonna: 2
                },
                altro: {
                    id: "altro",
                    field: "altro",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.21",
                    tipo: "input",
                    disabled: !this.state.malattiaBatterica.checkboxMalattia21,
                    required: this.state.malattiaBatterica.checkboxMalattia21,
                    colonna: 3
                },
            },
            {
                checkboxMalattia11: {
                    id: "checkboxMalattia11",
                    text: "SchedaFlussoSpeciale.MIB.MalattiaBatterica.11",
                    tipo: "check",
                    field: "checkboxMalattia11",
                    defaultChecked: this.state.malattiaBatterica.checkboxMalattia11,
                    fontColor: "black",
                    colonna: 1
                },
            },
        ]

        let boxes = Utils.createDiv("col-lg-4", "col-lg-3", "col-lg-3", this.riceviValore, this.state.malattiaBatterica, t, rows)
        return boxes
    }

    generateRadioDiv() {
        const {t} = this.props
        let radioRows = [
            {
                radio1: {
                    id: "esito1",
                    text: "SchedaFlussoSpeciale.MIB.Esito.guarito",
                    tipo: "radio",
                    name: "esitoConosciuto",
                    value: "1",
                    colonna: 1
                },
                radio2: {
                    id: "esito2",
                    text: "SchedaFlussoSpeciale.MIB.Esito.deceduto",
                    tipo: "radio",
                    name: "esitoConosciuto",
                    value: "2",
                    colonna: 2
                },
                radio3: {
                    id: "esito3",
                    text: "SchedaFlussoSpeciale.MIB.Esito.trattamento",
                    tipo: "radio",
                    name: "esitoConosciuto",
                    value: "3",
                    colonna: 3
                },
            }
        ]

        let radioBoxes = Utils.createDiv("col-lg-2", "col-lg-2", "col-lg-3", this.riceviValore, this.state.malattiaBatterica, t, radioRows)
        return radioBoxes
    }

    riceviValore(field, event) {
        let malattiaBatterica = this.state.malattiaBatterica
        malattiaBatterica[field] = event.target.value

        if (field.includes("checkboxMalattia") && malattiaBatterica[field] !== "true") {
            malattiaBatterica[field] = "";
        }
        if (!malattiaBatterica.checkboxMalattia21) {
            malattiaBatterica.altro = "";
        }
        let boxes = this.generateCheckBoxDiv()
        let radioBoxes = this.generateRadioDiv()
        this.setState({malattiaBatterica: malattiaBatterica, boxes: boxes, radioBoxes: radioBoxes});
        this.controlloDatiBatterica();
        let oggetto = this.createOggettoBE()
        this.props.setMalattiaBattericaMIB(this.state.malattiaBatterica, oggetto)
    }

    render() {
        const {t} = this.props;
        const sezione1 = (
            <div>
                <div>
                    <h6>{t("SchedaFlussoSpeciale.MIB.MalattiaBatterica.titolo")}</h6>
                    <hr className={stylesWelcome.hr}/>
                </div>
                <div className="container">
                    {this.state.boxes}
                </div>
            </div>
        );
        const sezione2 = (
            <div style={{paddingTop: "2rem"}}>
                <div>
                    <h6>{t("SchedaFlussoSpeciale.MIB.Esito.titolo")}</h6>
                    <hr className={stylesWelcome.hr}/>
                </div>
                <div className="container">
                    {this.state.radioBoxes}
                </div>
            </div>

        );

        return (
            <div>
                {sezione1}
                {sezione2}
            </div>

        )
    }

}

export default withTranslation('common')(MalattiaBattericaMIB)
